import type { MergedBalanceIndexKeys } from './types';

// Legacy persisted blotter id prefix from Treasury Management; keep value for backward compatibility.
export const HISTORICAL_BALANCE_BLOTTER_PREFIX = 'treasury-management/balances';
export const DEV_NOGROUP_GROUP = '$DEV_NOGROUP_GROUP';
export const KEYS_BY_COUNTERPARTY: MergedBalanceIndexKeys[] = ['marketAccountID', 'currency'];
export const KEYS_BY_ASSET: MergedBalanceIndexKeys[] = ['currency', 'marketAccountID'];

export const VisualizationVariants = ['Value', 'Equal'] as const;
export type VisualizationVariant = (typeof VisualizationVariants)[number];

/** Legacy default tab id; kept in blotter keys so column state stays stable. */
export const HISTORICAL_BALANCE_BLOTTER_INSTANCE_ID = 'default-treasury';
// Legacy persisted tabs id from Treasury Management; keep value for backward compatibility.
export const HISTORICAL_BALANCE_BLOTTER_TABS_ID = 'portfolio/treasury-mgmt-tabs';
